import { useState, useEffect } from "react"
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, CardText, ListGroup, ListGroupItem, Row, Col, Button, Input, Label } from "reactstrap";
import Moment from "react-moment";
import PanelHeader from "components/PanelHeader/PanelHeader";
import CallLogService from "core/api/CallLogService"


const View = () => {
    const { id } = useParams();
    const [logData, setLogData] = useState();
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        async function fetchData() {
            const callLog = await CallLogService.get(id);

            setLogData(callLog);

            setLoading(false);
        }
        fetchData();
    }, [])

    if (loading) return <>Loading</>;
    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h1 className="title">
                            Call Log
                        </h1>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">Call Log Information</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <ListGroup >
                                    <ListGroupItem>
                                        <strong>Call Direction:</strong> {logData.callDirection}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Phone Number:</strong> {logData.phoneNumber}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>DID:</strong> {logData.did}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Ref:</strong> {logData.agentEmail}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Date Processed:</strong> {logData.dateTimeProcessed != "0001-01-01T00:00:00Z" && <Moment>{logData.dateTimeProcessed}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Date Answered:</strong> {logData.dateTimeAnswered != "0001-01-01T00:00:00Z" && <Moment>{logData.dateTimeAnswered}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Date Ended:</strong> {logData.dateTimeEnded != "0001-01-01T00:00:00Z" && <Moment>{logData.dateTimeEnded}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Recording:</strong> {logData.recordingUrl && <a href={logData.recordingUrl} target='_blank'>{logData.recordingUrl}</a>}
                                    </ListGroupItem>


                                </ListGroup>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </div >

        </>
    )
}

export default View